
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectCustomerQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desiredConditions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kibou"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenpo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anken_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_kodate_new"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_kodate_old"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_mansion_new"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_mansion_old"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_tochi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kibou_jigyo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baikai_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"main_shop_user"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_shop_user"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":362}};
    doc.loc.source = {"body":"query SelectCustomerQuery($client: Int!) {\n  client(client: $client) {\n  desiredConditions {\n      kibou\n      client\n      tenpo\n      status\n      anken_type\n      kibou_kodate_new\n      kibou_kodate_old\n      kibou_mansion_new\n      kibou_mansion_old\n      kibou_tochi\n      kibou_jigyo\n      baikai_type\n      main_shop_user\n      sub_shop_user\n    }\n  }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SelectCustomerQuery"] = oneQuery(doc, "SelectCustomerQuery");
        
